import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React from 'react';
var Menu = /*#__PURE__*/function (_React$Component) {
  _inherits(Menu, _React$Component);
  var _super = _createSuper(Menu);
  function Menu() {
    var _this;
    _classCallCheck(this, Menu);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _this.getStyle = function () {
      var position = _this.props.position;
      var width = position.width;
      return {
        marginLeft: width - 10,
        marginTop: '30px'
      };
    };
    return _this;
  }
  _createClass(Menu, [{
    key: "render",
    value: function render() {
      var style = this.getStyle();
      return /*#__PURE__*/React.createElement("span", {
        className: "seafile-menu-container",
        style: style
      }, this.props.children);
    }
  }]);
  return Menu;
}(React.Component);
export default Menu;